import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MakeMoovStep } from './../model/make-moov-step';
import { IssueType } from './../model/issue-type.enum';
import { MatDrawer } from '@angular/material/sidenav';
import { PersonalUserData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { MatStepper } from '@angular/material/stepper';
import { UtilsService } from 'src/app/moov-common/services/utils/utils.service';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';

@Component({
  selector: 'app-make-moov-container',
  templateUrl: './make-moov-container.component.html',
  styleUrls: ['./make-moov-container.component.scss']
})
export class MakeMoovContainerComponent extends BaseComponent implements OnInit  {
  @Input() skipIssueSelection = false;
  @Input() selectedIssueId = "";
  @Input() opened: boolean = false;
  @Input() counterpartId: string = "";
  @Input() selectedMotivationId: string = "";
  @Input() presentTopBar : boolean = true;
  @Input() isSelectMoovForSelf : boolean = false;
  @Output() close = new EventEmitter();
  @ViewChild('wizardStepper', { static: false }) wizardStepper: MatStepper;
  
  STEPS_COUNT: number = 3;
  SELECT_ISSUE_STEP: number = 0;
  steps: MakeMoovStep[];
  currentStep: MakeMoovStep;
  issueType: IssueType;
  wizardState: number;
  counterpartDetails: PersonalUserData;
  poiInitials: string;
  chatParticipantInitials: string;

  constructor(private readonly userService : AbstractPersonalUserDataService) {
    super();
    this.steps = this.initializeSteps();
    this.currentStep = this.steps[0]; // no state keeping
    this.wizardState = 1;
  }
  
  ngOnInit(): void {

    super.ngOnInit();
    // console.log(`MMC makeDirectMoov issueId is ${this.selectedIssueId}, skipIssue is ${this.skipIssueSelection}`);
    if (this.skipIssueSelection){
      if (this.selectedIssueId !=""){
        this.wizardState = 2;
      }
    }

    // console.log (`MMC onInit SIS is ${this.skipIssueSelection}, SIid is ${this.selectedIssueId} SMid is ${this.selectedMotivationId} wt is ${this.wizardState} IMFS is ${this.isSelectMoovForSelf} counterpartId is ${this.counterpartId}`);

    this.getTeamMemberData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ifChanged(changes.counterpartId, ()=> this.getTeamMemberData());
    // if (changes.counterpartId.currentValue != changes.counterpartId.previousValue && !changes.counterpartId.firstChange){
    //   this.getTeamMemberData();
    // } 

    if (this.skipIssueSelection){
      if (this.selectedIssueId !=""){
        this.wizardState = 2;
      }
    }
  }

  getTeamMemberData(): void{
    if (this.counterpartId != undefined && this.counterpartId != "" && !this.isSelectMoovForSelf){
      // console.log(`MMC gtmd`);
      this.userService.getUserDetails(this.counterpartId).subscribe(userDetails => {
        this.counterpartDetails = userDetails;
        if (this.counterpartDetails) {
           this.poiInitials = this.utilsService.getInitialis(this.counterpartDetails.firstName, this.counterpartDetails.lastName);
        }
      });
    }
    else if (this.isSelectMoovForSelf){
      this.counterpartDetails = this.user!;
    }
  }
  closeWizard() {
    this.close.emit();
  }

  issueSelectedEvent(selectedIssueId: string) {
    // console.log(`make moov container selctedIssueId ` + selectedIssueId);
    this.selectedIssueId = selectedIssueId;
    this.completeStep(this.SELECT_ISSUE_STEP);
    if (this.selectedIssueId && this.selectedIssueId !="" )
    {
      this.wizardState = 2;
    }
    this.analytics.issueSelectedEvent(this.counterpartId, selectedIssueId);
  }

  completeStep(num: number) {
    // const step = this.wizardStepper.steps.get(num);
    // if (step)
    //   step.completed = true;
  }

  issueSelected(): void{
    if (this.selectedIssueId && this.selectedIssueId !="" )
    {
      this.wizardState = 2;
    }
  }

  private initializeSteps(): MakeMoovStep[] {
    let steps: MakeMoovStep[] = [];
    for (let i = 0; i < this.STEPS_COUNT; i++) {
      let step: MakeMoovStep = new MakeMoovStep(i);
      steps.push(step);
    }
    return steps;
  }

  public moovSelected():void{
    this.close.emit();
  }
}
